// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._cEKAZ2G8048eK {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.nEJfjHDPLJY5xJ {
  position: relative;
  align-items: center;
  justify-content: center;
  margin-right: var(--ds-space-negative-050, -4px);
  background-color: unset;
}
.nEJfjHDPLJY5xJ:hover {
  background-color: unset;
}
.aCO55I2dN_jEoA {
  margin: unset;
  border-radius: 50%;
  font-size: 12px;
  vertical-align: top;
}
.D1jdycS1oG_VZw {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.R_W_toGSEEUSSr {
  transition: background 0.3s ease;
  cursor: pointer;
}
.EPiJfmnJj8plK3:hover,
.EPiJfmnJj8plK3:focus {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"facepile": `_cEKAZ2G8048eK`,
	"avatar": `nEJfjHDPLJY5xJ`,
	"showMore": `aCO55I2dN_jEoA`,
	"showMoreDisabled": `D1jdycS1oG_VZw`,
	"showMoreClickable": `R_W_toGSEEUSSr`,
	"boardMenuShowMoreClickable": `EPiJfmnJj8plK3`
};
export default ___CSS_LOADER_EXPORT___;
